import * as i1 from '@angular/common';
import { AsyncPipe, CommonModule } from '@angular/common';
import * as i0 from '@angular/core';
import { HostBinding, Component, ContentChildren, Input, ChangeDetectionStrategy, EventEmitter, inject, ElementRef, HostListener, Output, Renderer2, ViewChild, ContentChild, Injectable, TemplateRef, Directive, signal, ViewContainerRef, NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Subject, fromEvent, takeUntil, filter, skip, take, BehaviorSubject, combineLatest } from 'rxjs';
import { first } from 'rxjs/operators';
import { trigger, transition, style, animate, group, state } from '@angular/animations';
import { unsubscribe } from '@tc/foundation/utilities';
const _c0 = ["*"];
const _c1 = ["stlr-drawer", ""];
const _c2 = ["stlr-header", ""];
const _c3 = ["menuHeadContainer"];
const _c4 = ["menuListContainer"];
function StlrPanelActionComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵdomElementStart(0, "div")(1, "button", 1);
    i0.ɵɵdomListener("click", function StlrPanelActionComponent_Conditional_0_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵtext(2, "Close");
    i0.ɵɵdomElementEnd()();
  }
}
function StlrPanelActionComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵprojection(2);
    i0.ɵɵconditionalCreate(3, StlrPanelActionComponent_Conditional_0_Conditional_3_Template, 3, 0, "div");
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fadeInSlow", i0.ɵɵpipeBind1(1, 2, ctx_r1.isOpen$));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.showClose ? 3 : -1);
  }
}
function StlrPanelFailComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵdomElementStart(0, "div")(1, "button", 1);
    i0.ɵɵdomListener("click", function StlrPanelFailComponent_Conditional_0_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵtext(2, "Close");
    i0.ɵɵdomElementEnd()();
  }
}
function StlrPanelFailComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵprojection(2);
    i0.ɵɵconditionalCreate(3, StlrPanelFailComponent_Conditional_0_Conditional_3_Template, 3, 0, "div");
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fadeInSlow", i0.ɵɵpipeBind1(1, 2, ctx_r1.isOpen$));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.showClose ? 3 : -1);
  }
}
function StlrPanelSuccessComponent_Conditional_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵdomElementStart(0, "div")(1, "button", 1);
    i0.ɵɵdomListener("click", function StlrPanelSuccessComponent_Conditional_0_Conditional_3_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.close());
    });
    i0.ɵɵtext(2, "Close");
    i0.ɵɵdomElementEnd()();
  }
}
function StlrPanelSuccessComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵprojection(2);
    i0.ɵɵconditionalCreate(3, StlrPanelSuccessComponent_Conditional_0_Conditional_3_Template, 3, 0, "div");
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@fadeInSlow", i0.ɵɵpipeBind1(1, 2, ctx_r1.isOpen$));
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.showClose ? 3 : -1);
  }
}
function StlrPanelComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵdomElementStart(0, "div", 0);
    i0.ɵɵpipe(1, "async");
    i0.ɵɵprojection(2);
    i0.ɵɵdomElementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("@dropdown", i0.ɵɵpipeBind1(1, 1, ctx_r0.isOpen$));
  }
}
const _c5 = ["viewContainer"];
class StlrCardSectionComponent {
  get hostClasses() {
    const _classes = ['stlr-card-section'];
    if (this.background) {
      _classes.push(this.background);
    }
    if (this.padding) {
      _classes.push(this.padding);
    }
    return _classes.join(' ');
  }
  static {
    this.ɵfac = function StlrCardSectionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrCardSectionComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrCardSectionComponent,
      selectors: [["stlr-card-section"]],
      hostVars: 2,
      hostBindings: function StlrCardSectionComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function StlrCardSectionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{--card__padding: var(--space--24);--card__padding--m: var(--space--32);--card__padding--l: var(--space--48);--card__padding--s: var(--space--16);--card__padding--xs: var(--space--8);--card__border-radius: var(--stlr-border-radius);--card__bg: var(--stlr-color__white);--card__border: var(--stlr-color__neutral--200);--card__gray-bg: var(--stlr-color__neutral--050);--card__gray-border: var(--stlr-color__neutral--200);--card__gray-border--flag: var(--stlr-color__neutral--700);--card__surface-bg: var(--stlr-color__neutral--050);--card__surface-border: var(--stlr-color__neutral--200);--card__surface-border--flag: var(--stlr-color__neutral--800);--card__primary-bg: var(--stlr-color__primary--extra-light);--card__primary-border: var(--stlr-color__primary--light);--card__primary-border--flag: var(--stlr-color__primary);--card__secondary-bg: var(--stlr-color__secondary--extra-light);--card__secondary-border: var(--stlr-color__secondary--light);--card__secondary-border--flag: var(--stlr-color__secondary);--card__info-bg: var(--stlr-color__info--extra-light);--card__info-border: var(--stlr-color__info--light);--card__info-border--flag: var(--stlr-color__info);--card__warn-bg: var(--stlr-color__warn--extra-light);--card__warn-border: var(--stlr-color__warn--light);--card__warn-border--flag: var(--stlr-color__warn);--card__error-bg: var(--stlr-color__error--extra-light);--card__error-border: var(--stlr-color__error--light);--card__error-border--flag: var(--stlr-color__error);--card__success-bg: var(--stlr-color__success--extra-light);--card__success-border: var(--stlr-color__success--light);--card__success-border--flag: var(--stlr-color__success);--card__subdued-border: var(--stlr-color__neutral--200);--card__subdued-border--flag: var(--stlr-color__neutral--700);--card__shadow: 0 3px 10px rgb(0 0 0 / .2);display:block;box-sizing:border-box}[_nghost-%COMP%]:not([color]){background-color:var(--card__bg);border:solid 1px var(--card__border)}@media screen and (max-width:60em){[_nghost-%COMP%]:not(.lrg), [_nghost-%COMP%]:not(.sml), [_nghost-%COMP%]:not(.med){padding:var(--card__padding--s)}}@media screen and (min-width:60em){[_nghost-%COMP%]:not(.lrg), [_nghost-%COMP%]:not(.sml), [_nghost-%COMP%]:not(.med){padding:var(--card__padding)}}.sml[_nghost-%COMP%]{padding:var(--card__padding--s)}@media screen and (max-width:60em){.med[_nghost-%COMP%]{padding:var(--card__padding)}}@media screen and (min-width:60em){.med[_nghost-%COMP%]{padding:var(--card__padding--m)}}@media screen and (max-width:60em){.lrg[_nghost-%COMP%]{padding:var(--card__padding)}}@media screen and (min-width:60em){.lrg[_nghost-%COMP%]{padding:var(--card__padding--l)}}.primary[_nghost-%COMP%]{background-color:var(--card__primary-bg);border:solid 1px var(--card__primary-border)}.primary[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__primary-bg)}.secondary[_nghost-%COMP%]{background-color:var(--card__secondary-bg);border:solid 1px var(--card__secondary-border)}.secondary[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__secondary-bg)}.info[_nghost-%COMP%]{background-color:var(--card__info-bg);border:solid 1px var(--card__info-border)}.info[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__info-bg)}.error[_nghost-%COMP%]{background-color:var(--card__error-bg);border:solid 1px var(--card__error-border)}.error[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__error-bg)}.warn[_nghost-%COMP%]{background-color:var(--card__warn-bg);border:solid 1px var(--card__warn-border)}.warn[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__warn-bg)}.success[_nghost-%COMP%]{background-color:var(--card__success-bg);border:solid 1px var(--card__success-border)}.success[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__success-bg)}.gray[_nghost-%COMP%]{background-color:var(--card__gray-bg);border:solid 1px var(--card__gray-border)}.gray[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__gray-bg)}.surface[_nghost-%COMP%]{background-color:var(--card__surface-bg);border:solid 1px var(--card__surface-border)}.surface[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__surface-bg)}.subdued[_nghost-%COMP%]{background-color:var(--card__subdued-bg);border:solid 1px var(--card__subdued-border)}.subdued[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__subdued-bg)}.dark[_nghost-%COMP%]{background-color:var(--card__dark-bg);border:solid 1px var(--card__dark-border)}.dark[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__dark-bg)}.light[_nghost-%COMP%]{background-color:var(--card__light-bg);border:solid 1px var(--card__light-border)}.light[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__light-bg)}.link[_nghost-%COMP%]{background-color:var(--card__link-bg);border:solid 1px var(--card__link-border)}.link[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__link-bg)}.flag-primary[_nghost-%COMP%]{border-left:solid 4px var(--card__primary-border--flag)}.flag-secondary[_nghost-%COMP%]{border-left:solid 4px var(--card__secondary-border--flag)}.flag-info[_nghost-%COMP%]{border-left:solid 4px var(--card__info-border--flag)}.flag-error[_nghost-%COMP%]{border-left:solid 4px var(--card__error-border--flag)}.flag-warn[_nghost-%COMP%]{border-left:solid 4px var(--card__warn-border--flag)}.flag-success[_nghost-%COMP%]{border-left:solid 4px var(--card__success-border--flag)}.flag-gray[_nghost-%COMP%]{border-left:solid 4px var(--card__gray-border--flag)}.flag-surface[_nghost-%COMP%]{border-left:solid 4px var(--card__surface-border--flag)}.flag-subdued[_nghost-%COMP%]{border-left:solid 4px var(--card__subdued-border--flag)}.flag-dark[_nghost-%COMP%]{border-left:solid 4px var(--card__dark-border--flag)}.flag-light[_nghost-%COMP%]{border-left:solid 4px var(--card__light-border--flag)}.flag-link[_nghost-%COMP%]{border-left:solid 4px var(--card__link-border--flag)}[_nghost-%COMP%]{border-left:0!important;border-right:0!important;border-top:0!important}[_nghost-%COMP%]:first-of-type{border-radius:var(--card__border-radius) var(--card__border-radius) 0 0}[_nghost-%COMP%]:last-of-type{border-radius:0 0 var(--card__border-radius) var(--card__border-radius);border-bottom:0!important}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrCardSectionComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-card-section',
      standalone: false,
      template: "<ng-content></ng-content>\n",
      styles: [":host{--card__padding: var(--space--24);--card__padding--m: var(--space--32);--card__padding--l: var(--space--48);--card__padding--s: var(--space--16);--card__padding--xs: var(--space--8);--card__border-radius: var(--stlr-border-radius);--card__bg: var(--stlr-color__white);--card__border: var(--stlr-color__neutral--200);--card__gray-bg: var(--stlr-color__neutral--050);--card__gray-border: var(--stlr-color__neutral--200);--card__gray-border--flag: var(--stlr-color__neutral--700);--card__surface-bg: var(--stlr-color__neutral--050);--card__surface-border: var(--stlr-color__neutral--200);--card__surface-border--flag: var(--stlr-color__neutral--800);--card__primary-bg: var(--stlr-color__primary--extra-light);--card__primary-border: var(--stlr-color__primary--light);--card__primary-border--flag: var(--stlr-color__primary);--card__secondary-bg: var(--stlr-color__secondary--extra-light);--card__secondary-border: var(--stlr-color__secondary--light);--card__secondary-border--flag: var(--stlr-color__secondary);--card__info-bg: var(--stlr-color__info--extra-light);--card__info-border: var(--stlr-color__info--light);--card__info-border--flag: var(--stlr-color__info);--card__warn-bg: var(--stlr-color__warn--extra-light);--card__warn-border: var(--stlr-color__warn--light);--card__warn-border--flag: var(--stlr-color__warn);--card__error-bg: var(--stlr-color__error--extra-light);--card__error-border: var(--stlr-color__error--light);--card__error-border--flag: var(--stlr-color__error);--card__success-bg: var(--stlr-color__success--extra-light);--card__success-border: var(--stlr-color__success--light);--card__success-border--flag: var(--stlr-color__success);--card__subdued-border: var(--stlr-color__neutral--200);--card__subdued-border--flag: var(--stlr-color__neutral--700);--card__shadow: 0 3px 10px rgb(0 0 0 / .2);display:block;box-sizing:border-box}:host:not([color]){background-color:var(--card__bg);border:solid 1px var(--card__border)}@media screen and (max-width:60em){:host:not(.lrg),:host:not(.sml),:host:not(.med){padding:var(--card__padding--s)}}@media screen and (min-width:60em){:host:not(.lrg),:host:not(.sml),:host:not(.med){padding:var(--card__padding)}}:host.sml{padding:var(--card__padding--s)}@media screen and (max-width:60em){:host.med{padding:var(--card__padding)}}@media screen and (min-width:60em){:host.med{padding:var(--card__padding--m)}}@media screen and (max-width:60em){:host.lrg{padding:var(--card__padding)}}@media screen and (min-width:60em){:host.lrg{padding:var(--card__padding--l)}}:host.primary{background-color:var(--card__primary-bg);border:solid 1px var(--card__primary-border)}:host.primary ::ng-deep .stlr-card-section{background-color:var(--card__primary-bg)}:host.secondary{background-color:var(--card__secondary-bg);border:solid 1px var(--card__secondary-border)}:host.secondary ::ng-deep .stlr-card-section{background-color:var(--card__secondary-bg)}:host.info{background-color:var(--card__info-bg);border:solid 1px var(--card__info-border)}:host.info ::ng-deep .stlr-card-section{background-color:var(--card__info-bg)}:host.error{background-color:var(--card__error-bg);border:solid 1px var(--card__error-border)}:host.error ::ng-deep .stlr-card-section{background-color:var(--card__error-bg)}:host.warn{background-color:var(--card__warn-bg);border:solid 1px var(--card__warn-border)}:host.warn ::ng-deep .stlr-card-section{background-color:var(--card__warn-bg)}:host.success{background-color:var(--card__success-bg);border:solid 1px var(--card__success-border)}:host.success ::ng-deep .stlr-card-section{background-color:var(--card__success-bg)}:host.gray{background-color:var(--card__gray-bg);border:solid 1px var(--card__gray-border)}:host.gray ::ng-deep .stlr-card-section{background-color:var(--card__gray-bg)}:host.surface{background-color:var(--card__surface-bg);border:solid 1px var(--card__surface-border)}:host.surface ::ng-deep .stlr-card-section{background-color:var(--card__surface-bg)}:host.subdued{background-color:var(--card__subdued-bg);border:solid 1px var(--card__subdued-border)}:host.subdued ::ng-deep .stlr-card-section{background-color:var(--card__subdued-bg)}:host.dark{background-color:var(--card__dark-bg);border:solid 1px var(--card__dark-border)}:host.dark ::ng-deep .stlr-card-section{background-color:var(--card__dark-bg)}:host.light{background-color:var(--card__light-bg);border:solid 1px var(--card__light-border)}:host.light ::ng-deep .stlr-card-section{background-color:var(--card__light-bg)}:host.link{background-color:var(--card__link-bg);border:solid 1px var(--card__link-border)}:host.link ::ng-deep .stlr-card-section{background-color:var(--card__link-bg)}:host.flag-primary{border-left:solid 4px var(--card__primary-border--flag)}:host.flag-secondary{border-left:solid 4px var(--card__secondary-border--flag)}:host.flag-info{border-left:solid 4px var(--card__info-border--flag)}:host.flag-error{border-left:solid 4px var(--card__error-border--flag)}:host.flag-warn{border-left:solid 4px var(--card__warn-border--flag)}:host.flag-success{border-left:solid 4px var(--card__success-border--flag)}:host.flag-gray{border-left:solid 4px var(--card__gray-border--flag)}:host.flag-surface{border-left:solid 4px var(--card__surface-border--flag)}:host.flag-subdued{border-left:solid 4px var(--card__subdued-border--flag)}:host.flag-dark{border-left:solid 4px var(--card__dark-border--flag)}:host.flag-light{border-left:solid 4px var(--card__light-border--flag)}:host.flag-link{border-left:solid 4px var(--card__link-border--flag)}:host{border-left:0!important;border-right:0!important;border-top:0!important}:host:first-of-type{border-radius:var(--card__border-radius) var(--card__border-radius) 0 0}:host:last-of-type{border-radius:0 0 var(--card__border-radius) var(--card__border-radius);border-bottom:0!important}\n"]
    }]
  }], null, {
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
class StlrCardComponent {
  get hostClasses() {
    const _classes = [];
    if (this.color) {
      _classes.push(this.color);
    }
    if (this.flagColor) {
      _classes.push('flag-' + this.flagColor);
    }
    if (this.padding) {
      _classes.push(this.padding);
    }
    if (this.type) {
      _classes.push(this.type);
    }
    return _classes.join(' ');
  }
  ngOnChanges() {
    this.sections?.forEach(section => {
      section.background = this.color;
      section.padding = this.padding;
    });
  }
  static {
    this.ɵfac = function StlrCardComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrCardComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrCardComponent,
      selectors: [["stlr-card"]],
      contentQueries: function StlrCardComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, StlrCardSectionComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.sections = _t);
        }
      },
      hostVars: 2,
      hostBindings: function StlrCardComponent_HostBindings(rf, ctx) {
        if (rf & 2) {
          i0.ɵɵclassMap(ctx.hostClasses);
        }
      },
      inputs: {
        color: "color",
        flagColor: "flagColor",
        padding: "padding",
        type: "type"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function StlrCardComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{--card__padding: var(--space--24);--card__padding--m: var(--space--32);--card__padding--l: var(--space--48);--card__padding--s: var(--space--16);--card__padding--xs: var(--space--8);--card__border-radius: var(--stlr-border-radius);--card__bg: var(--stlr-color__white);--card__border: var(--stlr-color__neutral--200);--card__gray-bg: var(--stlr-color__neutral--050);--card__gray-border: var(--stlr-color__neutral--200);--card__gray-border--flag: var(--stlr-color__neutral--700);--card__surface-bg: var(--stlr-color__neutral--050);--card__surface-border: var(--stlr-color__neutral--200);--card__surface-border--flag: var(--stlr-color__neutral--800);--card__primary-bg: var(--stlr-color__primary--extra-light);--card__primary-border: var(--stlr-color__primary--light);--card__primary-border--flag: var(--stlr-color__primary);--card__secondary-bg: var(--stlr-color__secondary--extra-light);--card__secondary-border: var(--stlr-color__secondary--light);--card__secondary-border--flag: var(--stlr-color__secondary);--card__info-bg: var(--stlr-color__info--extra-light);--card__info-border: var(--stlr-color__info--light);--card__info-border--flag: var(--stlr-color__info);--card__warn-bg: var(--stlr-color__warn--extra-light);--card__warn-border: var(--stlr-color__warn--light);--card__warn-border--flag: var(--stlr-color__warn);--card__error-bg: var(--stlr-color__error--extra-light);--card__error-border: var(--stlr-color__error--light);--card__error-border--flag: var(--stlr-color__error);--card__success-bg: var(--stlr-color__success--extra-light);--card__success-border: var(--stlr-color__success--light);--card__success-border--flag: var(--stlr-color__success);--card__subdued-border: var(--stlr-color__neutral--200);--card__subdued-border--flag: var(--stlr-color__neutral--700);--card__shadow: 0 3px 10px rgb(0 0 0 / .2);display:block;box-sizing:border-box}[_nghost-%COMP%]:not([color]){background-color:var(--card__bg);border:solid 1px var(--card__border)}@media screen and (max-width:60em){[_nghost-%COMP%]:not(.lrg), [_nghost-%COMP%]:not(.sml), [_nghost-%COMP%]:not(.med){padding:var(--card__padding--s)}}@media screen and (min-width:60em){[_nghost-%COMP%]:not(.lrg), [_nghost-%COMP%]:not(.sml), [_nghost-%COMP%]:not(.med){padding:var(--card__padding)}}.sml[_nghost-%COMP%]{padding:var(--card__padding--s)}@media screen and (max-width:60em){.med[_nghost-%COMP%]{padding:var(--card__padding)}}@media screen and (min-width:60em){.med[_nghost-%COMP%]{padding:var(--card__padding--m)}}@media screen and (max-width:60em){.lrg[_nghost-%COMP%]{padding:var(--card__padding)}}@media screen and (min-width:60em){.lrg[_nghost-%COMP%]{padding:var(--card__padding--l)}}.primary[_nghost-%COMP%]{background-color:var(--card__primary-bg);border:solid 1px var(--card__primary-border)}.primary[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__primary-bg)}.secondary[_nghost-%COMP%]{background-color:var(--card__secondary-bg);border:solid 1px var(--card__secondary-border)}.secondary[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__secondary-bg)}.info[_nghost-%COMP%]{background-color:var(--card__info-bg);border:solid 1px var(--card__info-border)}.info[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__info-bg)}.error[_nghost-%COMP%]{background-color:var(--card__error-bg);border:solid 1px var(--card__error-border)}.error[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__error-bg)}.warn[_nghost-%COMP%]{background-color:var(--card__warn-bg);border:solid 1px var(--card__warn-border)}.warn[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__warn-bg)}.success[_nghost-%COMP%]{background-color:var(--card__success-bg);border:solid 1px var(--card__success-border)}.success[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__success-bg)}.gray[_nghost-%COMP%]{background-color:var(--card__gray-bg);border:solid 1px var(--card__gray-border)}.gray[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__gray-bg)}.surface[_nghost-%COMP%]{background-color:var(--card__surface-bg);border:solid 1px var(--card__surface-border)}.surface[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__surface-bg)}.subdued[_nghost-%COMP%]{background-color:var(--card__subdued-bg);border:solid 1px var(--card__subdued-border)}.subdued[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__subdued-bg)}.dark[_nghost-%COMP%]{background-color:var(--card__dark-bg);border:solid 1px var(--card__dark-border)}.dark[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__dark-bg)}.light[_nghost-%COMP%]{background-color:var(--card__light-bg);border:solid 1px var(--card__light-border)}.light[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__light-bg)}.link[_nghost-%COMP%]{background-color:var(--card__link-bg);border:solid 1px var(--card__link-border)}.link[_nghost-%COMP%]     .stlr-card-section{background-color:var(--card__link-bg)}.flag-primary[_nghost-%COMP%]{border-left:solid 4px var(--card__primary-border--flag)}.flag-secondary[_nghost-%COMP%]{border-left:solid 4px var(--card__secondary-border--flag)}.flag-info[_nghost-%COMP%]{border-left:solid 4px var(--card__info-border--flag)}.flag-error[_nghost-%COMP%]{border-left:solid 4px var(--card__error-border--flag)}.flag-warn[_nghost-%COMP%]{border-left:solid 4px var(--card__warn-border--flag)}.flag-success[_nghost-%COMP%]{border-left:solid 4px var(--card__success-border--flag)}.flag-gray[_nghost-%COMP%]{border-left:solid 4px var(--card__gray-border--flag)}.flag-surface[_nghost-%COMP%]{border-left:solid 4px var(--card__surface-border--flag)}.flag-subdued[_nghost-%COMP%]{border-left:solid 4px var(--card__subdued-border--flag)}.flag-dark[_nghost-%COMP%]{border-left:solid 4px var(--card__dark-border--flag)}.flag-light[_nghost-%COMP%]{border-left:solid 4px var(--card__light-border--flag)}.flag-link[_nghost-%COMP%]{border-left:solid 4px var(--card__link-border--flag)}[_nghost-%COMP%]{border-radius:var(--card__border-radius)}.stack[_nghost-%COMP%]{padding:0}.elevate[_nghost-%COMP%]{box-shadow:var(--card__shadow);border:0!important}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrCardComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-card',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<ng-content></ng-content>\n",
      styles: [":host{--card__padding: var(--space--24);--card__padding--m: var(--space--32);--card__padding--l: var(--space--48);--card__padding--s: var(--space--16);--card__padding--xs: var(--space--8);--card__border-radius: var(--stlr-border-radius);--card__bg: var(--stlr-color__white);--card__border: var(--stlr-color__neutral--200);--card__gray-bg: var(--stlr-color__neutral--050);--card__gray-border: var(--stlr-color__neutral--200);--card__gray-border--flag: var(--stlr-color__neutral--700);--card__surface-bg: var(--stlr-color__neutral--050);--card__surface-border: var(--stlr-color__neutral--200);--card__surface-border--flag: var(--stlr-color__neutral--800);--card__primary-bg: var(--stlr-color__primary--extra-light);--card__primary-border: var(--stlr-color__primary--light);--card__primary-border--flag: var(--stlr-color__primary);--card__secondary-bg: var(--stlr-color__secondary--extra-light);--card__secondary-border: var(--stlr-color__secondary--light);--card__secondary-border--flag: var(--stlr-color__secondary);--card__info-bg: var(--stlr-color__info--extra-light);--card__info-border: var(--stlr-color__info--light);--card__info-border--flag: var(--stlr-color__info);--card__warn-bg: var(--stlr-color__warn--extra-light);--card__warn-border: var(--stlr-color__warn--light);--card__warn-border--flag: var(--stlr-color__warn);--card__error-bg: var(--stlr-color__error--extra-light);--card__error-border: var(--stlr-color__error--light);--card__error-border--flag: var(--stlr-color__error);--card__success-bg: var(--stlr-color__success--extra-light);--card__success-border: var(--stlr-color__success--light);--card__success-border--flag: var(--stlr-color__success);--card__subdued-border: var(--stlr-color__neutral--200);--card__subdued-border--flag: var(--stlr-color__neutral--700);--card__shadow: 0 3px 10px rgb(0 0 0 / .2);display:block;box-sizing:border-box}:host:not([color]){background-color:var(--card__bg);border:solid 1px var(--card__border)}@media screen and (max-width:60em){:host:not(.lrg),:host:not(.sml),:host:not(.med){padding:var(--card__padding--s)}}@media screen and (min-width:60em){:host:not(.lrg),:host:not(.sml),:host:not(.med){padding:var(--card__padding)}}:host.sml{padding:var(--card__padding--s)}@media screen and (max-width:60em){:host.med{padding:var(--card__padding)}}@media screen and (min-width:60em){:host.med{padding:var(--card__padding--m)}}@media screen and (max-width:60em){:host.lrg{padding:var(--card__padding)}}@media screen and (min-width:60em){:host.lrg{padding:var(--card__padding--l)}}:host.primary{background-color:var(--card__primary-bg);border:solid 1px var(--card__primary-border)}:host.primary ::ng-deep .stlr-card-section{background-color:var(--card__primary-bg)}:host.secondary{background-color:var(--card__secondary-bg);border:solid 1px var(--card__secondary-border)}:host.secondary ::ng-deep .stlr-card-section{background-color:var(--card__secondary-bg)}:host.info{background-color:var(--card__info-bg);border:solid 1px var(--card__info-border)}:host.info ::ng-deep .stlr-card-section{background-color:var(--card__info-bg)}:host.error{background-color:var(--card__error-bg);border:solid 1px var(--card__error-border)}:host.error ::ng-deep .stlr-card-section{background-color:var(--card__error-bg)}:host.warn{background-color:var(--card__warn-bg);border:solid 1px var(--card__warn-border)}:host.warn ::ng-deep .stlr-card-section{background-color:var(--card__warn-bg)}:host.success{background-color:var(--card__success-bg);border:solid 1px var(--card__success-border)}:host.success ::ng-deep .stlr-card-section{background-color:var(--card__success-bg)}:host.gray{background-color:var(--card__gray-bg);border:solid 1px var(--card__gray-border)}:host.gray ::ng-deep .stlr-card-section{background-color:var(--card__gray-bg)}:host.surface{background-color:var(--card__surface-bg);border:solid 1px var(--card__surface-border)}:host.surface ::ng-deep .stlr-card-section{background-color:var(--card__surface-bg)}:host.subdued{background-color:var(--card__subdued-bg);border:solid 1px var(--card__subdued-border)}:host.subdued ::ng-deep .stlr-card-section{background-color:var(--card__subdued-bg)}:host.dark{background-color:var(--card__dark-bg);border:solid 1px var(--card__dark-border)}:host.dark ::ng-deep .stlr-card-section{background-color:var(--card__dark-bg)}:host.light{background-color:var(--card__light-bg);border:solid 1px var(--card__light-border)}:host.light ::ng-deep .stlr-card-section{background-color:var(--card__light-bg)}:host.link{background-color:var(--card__link-bg);border:solid 1px var(--card__link-border)}:host.link ::ng-deep .stlr-card-section{background-color:var(--card__link-bg)}:host.flag-primary{border-left:solid 4px var(--card__primary-border--flag)}:host.flag-secondary{border-left:solid 4px var(--card__secondary-border--flag)}:host.flag-info{border-left:solid 4px var(--card__info-border--flag)}:host.flag-error{border-left:solid 4px var(--card__error-border--flag)}:host.flag-warn{border-left:solid 4px var(--card__warn-border--flag)}:host.flag-success{border-left:solid 4px var(--card__success-border--flag)}:host.flag-gray{border-left:solid 4px var(--card__gray-border--flag)}:host.flag-surface{border-left:solid 4px var(--card__surface-border--flag)}:host.flag-subdued{border-left:solid 4px var(--card__subdued-border--flag)}:host.flag-dark{border-left:solid 4px var(--card__dark-border--flag)}:host.flag-light{border-left:solid 4px var(--card__light-border--flag)}:host.flag-link{border-left:solid 4px var(--card__link-border--flag)}:host{border-radius:var(--card__border-radius)}:host.stack{padding:0}:host.elevate{box-shadow:var(--card__shadow);border:0!important}\n"]
    }]
  }], null, {
    color: [{
      type: Input
    }],
    flagColor: [{
      type: Input
    }],
    padding: [{
      type: Input
    }],
    type: [{
      type: Input
    }],
    sections: [{
      type: ContentChildren,
      args: [StlrCardSectionComponent]
    }],
    hostClasses: [{
      type: HostBinding,
      args: ['class']
    }]
  });
})();
class StlrDrawerComponent {
  constructor() {
    this.type = 'pinned';
    this.closed = new EventEmitter();
    this._ref = inject(ElementRef);
    this._unsub$ = new Subject();
    this._outsideClick$ = fromEvent(window, 'click').pipe(takeUntil(this._unsub$), filter(ev => !this._ref.nativeElement.contains(ev.target)));
  }
  get isFilters() {
    return this.type === 'filters';
  }
  get isPinned() {
    return this.type === 'pinned';
  }
  get isArticle() {
    return this.type === 'article';
  }
  onKeydownHandler() {
    this.closed.emit();
  }
  ngOnChanges(changes) {
    if (changes["open"]) {
      // 'outside clicks' only relevant when open, skip first outside click (initial trigger), and unsub after one emission
      if (this.open) {
        this._outsideClick$.pipe(skip(1), take(1)).subscribe(() => this.closed.emit());
      } else {
        this._unsub$.next();
      }
    }
  }
  ngOnDestroy() {
    this._unsub$.next();
    this._unsub$.complete();
  }
  static {
    this.ɵfac = function StlrDrawerComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrDrawerComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrDrawerComponent,
      selectors: [["aside", "stlr-drawer", ""], ["stlr-drawer"], ["aside", "stlrDrawer", ""], ["stlrDrawer"]],
      hostVars: 8,
      hostBindings: function StlrDrawerComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keydown.escape", function StlrDrawerComponent_keydown_escape_HostBindingHandler($event) {
            return ctx.onKeydownHandler($event);
          }, i0.ɵɵresolveDocument);
        }
        if (rf & 2) {
          i0.ɵɵclassProp("open", ctx.open)("filters", ctx.isFilters)("pinned", ctx.isPinned)("article", ctx.isArticle);
        }
      },
      inputs: {
        type: "type",
        open: "open"
      },
      outputs: {
        closed: "closed"
      },
      standalone: false,
      features: [i0.ɵɵNgOnChangesFeature],
      attrs: _c1,
      ngContentSelectors: _c0,
      decls: 2,
      vars: 0,
      consts: [[1, "drawer-content"]],
      template: function StlrDrawerComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵprojection(1);
          i0.ɵɵelementEnd();
        }
      },
      styles: ["[_nghost-%COMP%]   .drawer-content[_ngcontent-%COMP%]{position:relative;display:flex;flex-direction:column;z-index:900;min-width:220px;max-width:14rem;height:100%;padding:var(--space--16);background-color:#fff;box-sizing:border-box;border-radius:var(--stlr-border-radius);border:solid 1px var(--stlr-color__neutral--200)}[_nghost-%COMP%]     nav, [_nghost-%COMP%]     div{margin:0;padding:0;display:flex;flex-direction:column}[_nghost-%COMP%]     ul{margin:0;padding:0;display:flex;flex-direction:column;gap:var(--space-s)}[_nghost-%COMP%]     li{display:flex;flex-direction:column;gap:var(--space-s);list-style:none}[_nghost-%COMP%]     li ul{padding-inline-start:1.5rem}[_nghost-%COMP%]     a{display:block;position:relative;padding:var(--space-xs) var(--space-m);white-space:nowrap;text-decoration:none;color:var(--stlr-color__copy);border-radius:var(--stlr-border-radius);background-color:transparent;transition:all .2s ease-in-out;font-size:.875rem}[_nghost-%COMP%]     a:hover{color:var(--stlr-color__primary)}[_nghost-%COMP%]     a:focus-visible{outline:solid 2px var(--stlr-color__info);transition:outline-offset .25s ease}[_nghost-%COMP%]     a.is-active{background-color:var(--stlr-color__primary);color:#fff}[_nghost-%COMP%]     a.is-active *{color:#fff}.filters[_nghost-%COMP%]{box-shadow:24px -1px 18px 20px #000000bf;border:0;border-radius:0;padding:var(--space--24)}.filters.open[_nghost-%COMP%]{visibility:visible;right:calc(-1 * var(--space-xxs));transition:visibility 0s 0s,left .2s}.filters.open[_nghost-%COMP%]   .backdrop[_ngcontent-%COMP%]{opacity:.5}.filters[_nghost-%COMP%]:not(.open){visibility:hidden;right:-300px;transition:visibility 0s .2s,left .2s}.filters[_nghost-%COMP%]:not(.open)   .backdrop[_ngcontent-%COMP%]{opacity:0}.filters[_nghost-%COMP%]{position:fixed;top:calc(-1 * var(--space-xxs));bottom:calc(-1 * var(--space-xxs));z-index:800}.filters[_nghost-%COMP%]     nav, .filters[_nghost-%COMP%]     div{height:100%;flex-grow:1;position:relative;z-index:900}.filters[_nghost-%COMP%]   .backdrop[_ngcontent-%COMP%]{content:\"\";position:absolute;width:calc(100vw + 250px);inset:0;background-color:#000;transition:opacity .2s;z-index:1}.article[_nghost-%COMP%]{transition:visibility 0s .2s,right .2s ease-out;position:fixed;z-index:800;height:calc(100% - (var(--space--56) - 2px));top:calc(var(--space--56) - 2px);bottom:0;padding:0;box-shadow:none;border:0;border-radius:0}.article[_nghost-%COMP%]     .drawer-content{padding:0 0 var(--space--56);min-width:320px;width:839px;max-width:100vw}.article[_nghost-%COMP%]     .drawer-content div{display:block}.article[_nghost-%COMP%]     .drawer-content ul{display:block;margin-bottom:1.5rem;padding-inline-start:1.5rem}.article[_nghost-%COMP%]     .drawer-content ul li{list-style:inside disc}.article[_nghost-%COMP%]     .drawer-content ol{display:block;margin-bottom:1.5rem}.article[_nghost-%COMP%]     .drawer-content ol li{list-style:inside decimal}.article[_nghost-%COMP%]     .drawer-content li{display:list-item}.article[_nghost-%COMP%]     .drawer-content li ul{padding-inline-start:1.5rem}.article[_nghost-%COMP%]     .drawer-content li p{display:inline-block}.article[_nghost-%COMP%]     .drawer-content a{display:inline;padding:0;color:var(--stlr-color__info);font-size:initial}.article[_nghost-%COMP%]     header{padding:var(--space--16);border-bottom:1px solid #DFDFDF}.article[_nghost-%COMP%]     .article-content{padding:var(--space--32) var(--space--56)}.article[_nghost-%COMP%]   .backdrop[_ngcontent-%COMP%]{content:\"\";position:absolute;width:calc(100vw + 250px);inset:0;background-color:#000;transition:opacity .2s;z-index:1}.article.open[_nghost-%COMP%]{visibility:visible;right:0;transition:right .2s ease-out}.article.open[_nghost-%COMP%]   .backdrop[_ngcontent-%COMP%]{opacity:.5}.article[_nghost-%COMP%]:not(.open){visibility:hidden;transition:visibility 0s .2s,right .2s ease-out;right:-839px}.article[_nghost-%COMP%]:not(.open)   .backdrop[_ngcontent-%COMP%]{opacity:0}@media(max-width:60em){[_nghost-%COMP%]:not(.filters):not(.article).open{visibility:visible;left:calc(-1 * var(--space-xxs));transition:visibility 0s 0s,left .2s}[_nghost-%COMP%]:not(.filters):not(.article).open   .backdrop[_ngcontent-%COMP%]{opacity:.5}[_nghost-%COMP%]:not(.filters):not(.article):not(.open){visibility:hidden;left:-250px;transition:visibility 0s .2s,left .2s}[_nghost-%COMP%]:not(.filters):not(.article):not(.open)   .backdrop[_ngcontent-%COMP%]{opacity:0}[_nghost-%COMP%]:not(.filters):not(.article){position:fixed;top:calc(-1 * var(--space-xxs));bottom:calc(-1 * var(--space-xxs));z-index:800}[_nghost-%COMP%]:not(.filters):not(.article)     nav{height:100%;flex-grow:1;position:relative;z-index:900}[_nghost-%COMP%]:not(.filters):not(.article)   .backdrop[_ngcontent-%COMP%]{content:\"\";position:absolute;width:calc(100vw + 250px);inset:0;background-color:#000;transition:opacity .2s;z-index:1}}"],
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrDrawerComponent, [{
    type: Component,
    args: [{
      selector: 'aside[stlr-drawer], stlr-drawer, aside[stlrDrawer], stlrDrawer',
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div class=\"drawer-content\">\n    <ng-content></ng-content>\n</div>\n",
      styles: [":host .drawer-content{position:relative;display:flex;flex-direction:column;z-index:900;min-width:220px;max-width:14rem;height:100%;padding:var(--space--16);background-color:#fff;box-sizing:border-box;border-radius:var(--stlr-border-radius);border:solid 1px var(--stlr-color__neutral--200)}:host ::ng-deep nav,:host ::ng-deep div{margin:0;padding:0;display:flex;flex-direction:column}:host ::ng-deep ul{margin:0;padding:0;display:flex;flex-direction:column;gap:var(--space-s)}:host ::ng-deep li{display:flex;flex-direction:column;gap:var(--space-s);list-style:none}:host ::ng-deep li ul{padding-inline-start:1.5rem}:host ::ng-deep a{display:block;position:relative;padding:var(--space-xs) var(--space-m);white-space:nowrap;text-decoration:none;color:var(--stlr-color__copy);border-radius:var(--stlr-border-radius);background-color:transparent;transition:all .2s ease-in-out;font-size:.875rem}:host ::ng-deep a:hover{color:var(--stlr-color__primary)}:host ::ng-deep a:focus-visible{outline:solid 2px var(--stlr-color__info);transition:outline-offset .25s ease}:host ::ng-deep a.is-active{background-color:var(--stlr-color__primary);color:#fff}:host ::ng-deep a.is-active *{color:#fff}:host.filters{box-shadow:24px -1px 18px 20px #000000bf;border:0;border-radius:0;padding:var(--space--24)}:host.filters.open{visibility:visible;right:calc(-1 * var(--space-xxs));transition:visibility 0s 0s,left .2s}:host.filters.open .backdrop{opacity:.5}:host.filters:not(.open){visibility:hidden;right:-300px;transition:visibility 0s .2s,left .2s}:host.filters:not(.open) .backdrop{opacity:0}:host.filters{position:fixed;top:calc(-1 * var(--space-xxs));bottom:calc(-1 * var(--space-xxs));z-index:800}:host.filters ::ng-deep nav,:host.filters ::ng-deep div{height:100%;flex-grow:1;position:relative;z-index:900}:host.filters .backdrop{content:\"\";position:absolute;width:calc(100vw + 250px);inset:0;background-color:#000;transition:opacity .2s;z-index:1}:host.article{transition:visibility 0s .2s,right .2s ease-out;position:fixed;z-index:800;height:calc(100% - (var(--space--56) - 2px));top:calc(var(--space--56) - 2px);bottom:0;padding:0;box-shadow:none;border:0;border-radius:0}:host.article ::ng-deep .drawer-content{padding:0 0 var(--space--56);min-width:320px;width:839px;max-width:100vw}:host.article ::ng-deep .drawer-content div{display:block}:host.article ::ng-deep .drawer-content ul{display:block;margin-bottom:1.5rem;padding-inline-start:1.5rem}:host.article ::ng-deep .drawer-content ul li{list-style:inside disc}:host.article ::ng-deep .drawer-content ol{display:block;margin-bottom:1.5rem}:host.article ::ng-deep .drawer-content ol li{list-style:inside decimal}:host.article ::ng-deep .drawer-content li{display:list-item}:host.article ::ng-deep .drawer-content li ul{padding-inline-start:1.5rem}:host.article ::ng-deep .drawer-content li p{display:inline-block}:host.article ::ng-deep .drawer-content a{display:inline;padding:0;color:var(--stlr-color__info);font-size:initial}:host.article ::ng-deep header{padding:var(--space--16);border-bottom:1px solid #DFDFDF}:host.article ::ng-deep .article-content{padding:var(--space--32) var(--space--56)}:host.article .backdrop{content:\"\";position:absolute;width:calc(100vw + 250px);inset:0;background-color:#000;transition:opacity .2s;z-index:1}:host.article.open{visibility:visible;right:0;transition:right .2s ease-out}:host.article.open .backdrop{opacity:.5}:host.article:not(.open){visibility:hidden;transition:visibility 0s .2s,right .2s ease-out;right:-839px}:host.article:not(.open) .backdrop{opacity:0}@media(max-width:60em){:host:not(.filters):not(.article).open{visibility:visible;left:calc(-1 * var(--space-xxs));transition:visibility 0s 0s,left .2s}:host:not(.filters):not(.article).open .backdrop{opacity:.5}:host:not(.filters):not(.article):not(.open){visibility:hidden;left:-250px;transition:visibility 0s .2s,left .2s}:host:not(.filters):not(.article):not(.open) .backdrop{opacity:0}:host:not(.filters):not(.article){position:fixed;top:calc(-1 * var(--space-xxs));bottom:calc(-1 * var(--space-xxs));z-index:800}:host:not(.filters):not(.article) ::ng-deep nav{height:100%;flex-grow:1;position:relative;z-index:900}:host:not(.filters):not(.article) .backdrop{content:\"\";position:absolute;width:calc(100vw + 250px);inset:0;background-color:#000;transition:opacity .2s;z-index:1}}\n"]
    }]
  }], null, {
    type: [{
      type: Input
    }],
    open: [{
      type: HostBinding,
      args: ['class.open']
    }, {
      type: Input
    }],
    closed: [{
      type: Output
    }],
    isFilters: [{
      type: HostBinding,
      args: ['class.filters']
    }],
    isPinned: [{
      type: HostBinding,
      args: ['class.pinned']
    }],
    isArticle: [{
      type: HostBinding,
      args: ['class.article']
    }],
    onKeydownHandler: [{
      type: HostListener,
      args: ['document:keydown.escape', ['$event']]
    }]
  });
})();
class StlrHeaderColumnComponent {
  static {
    this.ɵfac = function StlrHeaderColumnComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrHeaderColumnComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrHeaderColumnComponent,
      selectors: [["stlr-header-column"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function StlrHeaderColumnComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:flex;flex-direction:row;align-items:center;gap:var(--space--8)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrHeaderColumnComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-header-column',
      standalone: false,
      template: "<ng-content></ng-content>\n",
      styles: [":host{display:flex;flex-direction:row;align-items:center;gap:var(--space--8)}\n"]
    }]
  }], null, null);
})();
class StlrHeaderComponent {
  static {
    this.ɵfac = function StlrHeaderComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrHeaderComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrHeaderComponent,
      selectors: [["header", "stlr-header", ""], ["header", "stlrHeader", ""]],
      standalone: false,
      attrs: _c2,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function StlrHeaderComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:flex;flex-direction:row;align-items:center;height:var(--space--56);padding:0 var(--space--16);background-color:var(--stlr-color__white);border-bottom:solid 1px var(--stlr-color__neutral--150)}@media screen and (min-width:60em){[_nghost-%COMP%]:not([height=short]){height:var(--space--72)}}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrHeaderComponent, [{
    type: Component,
    args: [{
      selector: 'header[stlr-header], header[stlrHeader]',
      standalone: false,
      template: "<ng-content></ng-content>\n",
      styles: [":host{display:flex;flex-direction:row;align-items:center;height:var(--space--56);padding:0 var(--space--16);background-color:var(--stlr-color__white);border-bottom:solid 1px var(--stlr-color__neutral--150)}@media screen and (min-width:60em){:host:not([height=short]){height:var(--space--72)}}\n"]
    }]
  }], null, null);
})();
class StlrMenuHeadComponent {
  #elementRef = inject(ElementRef);
  /**
   * Used to attach self to the passed in HTML element
   * @ignore
   * @param headContainerElement
   */
  addToHeadContainer(headContainerElement) {
    headContainerElement.appendChild(this.#elementRef.nativeElement);
  }
  /**
   * Utility function to pass the isOpen$ observable from the stlr-menu
   * @ignore
   * @param isOpen$
   */
  setIsOpen(isOpen$) {
    // TODO but not today: This should be done via service
    this.isOpen$ = isOpen$;
  }
  static {
    this.ɵfac = function StlrMenuHeadComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrMenuHeadComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrMenuHeadComponent,
      selectors: [["stlr-menu-head"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 3,
      vars: 3,
      consts: [[1, "stlr-menu-head", 3, "ngClass"]],
      template: function StlrMenuHeadComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 0);
          i0.ɵɵpipe(1, "async");
          i0.ɵɵprojection(2);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(1, 1, ctx.isOpen$) ? "is-open" : "is-closed");
        }
      },
      dependencies: [i1.NgClass, i1.AsyncPipe],
      styles: [".stlr-menu-head[_ngcontent-%COMP%]{position:relative;display:flex;cursor:pointer}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrMenuHeadComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-menu-head',
      standalone: false,
      template: "<div\n    class=\"stlr-menu-head\"\n    [ngClass]=\"(isOpen$ | async) ? 'is-open' : 'is-closed'\"\n>\n    <ng-content></ng-content>\n</div>\n",
      styles: [".stlr-menu-head{position:relative;display:flex;cursor:pointer}\n"]
    }]
  }], null, null);
})();
class StlrMenuItemComponent {
  constructor() {
    this._elementRef = inject(ElementRef);
  }
  /**
   * Used to attach self to passed in element
   * @ignore
   * @param listContainerElement
   */
  addToMenuListContainer(listContainerElement) {
    listContainerElement.appendChild(this._elementRef.nativeElement);
  }
  static {
    this.ɵfac = function StlrMenuItemComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrMenuItemComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrMenuItemComponent,
      selectors: [["stlr-menu-item"]],
      standalone: false,
      ngContentSelectors: _c0,
      decls: 1,
      vars: 0,
      template: function StlrMenuItemComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵprojection(0);
        }
      },
      styles: ["[_nghost-%COMP%]{display:block;cursor:pointer;width:100%;padding:.5em 1em;transition:all .2s ease-in-out;white-space:nowrap;font-size:.9em}[_nghost-%COMP%]:first-of-type{margin-top:.5em}[_nghost-%COMP%]:last-of-type{margin-bottom:.5em}[_nghost-%COMP%]     a{color:var(--stlr-color__copy);text-decoration:none}[_nghost-%COMP%]     a.is-active{font-weight:700;color:var(--stlr-color__link)}[_nghost-%COMP%]     a:hover{color:var(--stlr-color__link)}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrMenuItemComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-menu-item',
      standalone: false,
      template: "<ng-content></ng-content>",
      styles: [":host{display:block;cursor:pointer;width:100%;padding:.5em 1em;transition:all .2s ease-in-out;white-space:nowrap;font-size:.9em}:host:first-of-type{margin-top:.5em}:host:last-of-type{margin-bottom:.5em}:host ::ng-deep a{color:var(--stlr-color__copy);text-decoration:none}:host ::ng-deep a.is-active{font-weight:700;color:var(--stlr-color__link)}:host ::ng-deep a:hover{color:var(--stlr-color__link)}\n"]
    }]
  }], null, null);
})();

// noinspection ES6PreferShortImport
class StlrMenuComponent {
  /**
   * Listens for the enter key being pressed and toggles the menu
   */
  onKeydownHandler() {
    this.isOpen$.pipe(first()).subscribe(isOpen => {
      this._isOpenSubject.next(!isOpen);
    });
  }
  /**
   * If openOnHover, listens for the mouse to hover the menu head, then opens the menu
   */
  onMouseEnter() {
    if (this.openOnHover) {
      this._isOpenSubject.next(true);
    }
  }
  /**
   * If openOnHover, listens for the mouse to leave the menu head, then closes the menu
   */
  onMouseLeave() {
    if (this.openOnHover) {
      this._isOpenSubject.next(false);
    }
  }
  /**
   * Listens for the escape key being pressed, then closes the menu
   */
  onEscape() {
    this._isOpenSubject.next(false);
  }
  constructor() {
    this._elementRef = inject(ElementRef);
    this._isOpenSubject = new BehaviorSubject(false);
    /**
     * An observable boolean that indicates if the menu is open or not
     */
    this.isOpen$ = this._isOpenSubject.asObservable();
    this._renderer = inject(Renderer2);
    /**
     * A boolean indicating whether to open when the user hovers over the menu head or
     * wait for a click. Defaults to false.
     */
    this.openOnHover = false;
    // Used to handle click events outside this component - the blur HostListener didn't work
    this._removeClickEventListener = this._renderer.listen('window', 'click', event => {
      this.isOpen$.pipe(first()).subscribe(isOpen => {
        if (event.target === this._elementRef.nativeElement || this._elementRef.nativeElement.contains(event.target)) {
          this._isOpenSubject.next(!isOpen);
        } else {
          if (isOpen) {
            this._isOpenSubject.next(false);
          }
        }
      });
    });
  }
  ngAfterViewInit() {
    this.head?.setIsOpen(this.isOpen$);
    if (!this.menuHeadContainerRef) {
      console.warn('stlr-menu-head-container not found inside stlr-menu');
      return;
    }
    this.head?.addToHeadContainer(this.menuHeadContainerRef?.nativeElement);
    this.menuItems?.forEach(item => {
      if (!this.menuListContainerRef) {
        console.warn('stlr-menu-list-container not found inside stlr-menu');
        return;
      }
      item.addToMenuListContainer(this.menuListContainerRef?.nativeElement);
    });
  }
  ngOnDestroy() {
    this._removeClickEventListener();
  }
  static {
    this.ɵfac = function StlrMenuComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrMenuComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrMenuComponent,
      selectors: [["stlr-menu"]],
      contentQueries: function StlrMenuComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, StlrMenuHeadComponent, 7);
          i0.ɵɵcontentQuery(dirIndex, StlrMenuItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.head = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuItems = _t);
        }
      },
      viewQuery: function StlrMenuComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c3, 7);
          i0.ɵɵviewQuery(_c4, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuHeadContainerRef = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.menuListContainerRef = _t.first);
        }
      },
      hostBindings: function StlrMenuComponent_HostBindings(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵlistener("keyup.enter", function StlrMenuComponent_keyup_enter_HostBindingHandler() {
            return ctx.onKeydownHandler();
          })("mouseenter", function StlrMenuComponent_mouseenter_HostBindingHandler() {
            return ctx.onMouseEnter();
          })("mouseleave", function StlrMenuComponent_mouseleave_HostBindingHandler() {
            return ctx.onMouseLeave();
          })("keyup.escape", function StlrMenuComponent_keyup_escape_HostBindingHandler() {
            return ctx.onEscape();
          }, i0.ɵɵresolveDocument);
        }
      },
      inputs: {
        openOnHover: "openOnHover"
      },
      standalone: false,
      ngContentSelectors: _c0,
      decls: 9,
      vars: 6,
      consts: [["menuContainer", ""], ["menuHeadContainer", ""], ["menuListContainer", ""], [1, "stlr-menu-container"], ["role", "list", 1, "stlr-menu-list", 3, "ngClass"]],
      template: function StlrMenuComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵelementStart(0, "div", 3, 0);
          i0.ɵɵelement(2, "div", null, 1)(4, "div", 4, 2);
          i0.ɵɵpipe(6, "async");
          i0.ɵɵpipe(7, "async");
          i0.ɵɵelementEnd();
          i0.ɵɵprojection(8);
        }
        if (rf & 2) {
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngClass", i0.ɵɵpipeBind1(6, 2, ctx.isOpen$) ? "is-open" : "is-closed");
          i0.ɵɵattribute("aria-hidden", i0.ɵɵpipeBind1(7, 4, ctx.isOpen$) === false);
        }
      },
      dependencies: [i1.NgClass, i1.AsyncPipe],
      styles: ["[_nghost-%COMP%]   .stlr-menu-container[_ngcontent-%COMP%]{position:relative;height:100%}[_nghost-%COMP%]   .stlr-menu-list[_ngcontent-%COMP%]{position:absolute;z-index:800;margin:0;min-width:250px;box-shadow:0 2px 4px #00000040;background:#fff;border-top:none;right:0;transform:translateY(8px);list-style:none;display:none}[_nghost-%COMP%]   .stlr-menu-list.is-open[_ngcontent-%COMP%]{border-top:none;display:block}"]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrMenuComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-menu',
      standalone: false,
      template: "<div #menuContainer class=\"stlr-menu-container\">\n    <div #menuHeadContainer></div>\n    <div\n        role=\"list\"\n        #menuListContainer\n        class=\"stlr-menu-list\"\n        [ngClass]=\"(isOpen$ | async) ? 'is-open' : 'is-closed'\"\n        [attr.aria-hidden]=\"(isOpen$ | async) === false\"\n    ></div>\n</div>\n<ng-content></ng-content>\n",
      styles: [":host .stlr-menu-container{position:relative;height:100%}:host .stlr-menu-list{position:absolute;z-index:800;margin:0;min-width:250px;box-shadow:0 2px 4px #00000040;background:#fff;border-top:none;right:0;transform:translateY(8px);list-style:none;display:none}:host .stlr-menu-list.is-open{border-top:none;display:block}\n"]
    }]
  }], () => [], {
    openOnHover: [{
      type: Input
    }],
    head: [{
      type: ContentChild,
      args: [StlrMenuHeadComponent, {
        static: true
      }]
    }],
    menuItems: [{
      type: ContentChildren,
      args: [StlrMenuItemComponent]
    }],
    menuHeadContainerRef: [{
      type: ViewChild,
      args: ['menuHeadContainer', {
        static: true
      }]
    }],
    menuListContainerRef: [{
      type: ViewChild,
      args: ['menuListContainer', {
        static: true
      }]
    }],
    onKeydownHandler: [{
      type: HostListener,
      args: ['keyup.enter']
    }],
    onMouseEnter: [{
      type: HostListener,
      args: ['mouseenter']
    }],
    onMouseLeave: [{
      type: HostListener,
      args: ['mouseleave']
    }],
    onEscape: [{
      type: HostListener,
      args: ['document:keyup.escape']
    }]
  });
})();
let Animations$1 = class Animations {
  static {
    this.dropdown = trigger('dropdown', [transition(':enter', [style({
      opacity: 0,
      height: '0px'
      // 'padding-top': '0px',
      // 'padding-bottom': '0px',
      // 'margin-top': '0px',
      // 'margin-bottom': '0px'
    }), animate('350ms ease-in', style({
      opacity: 1,
      height: '*'
      // 'padding-top': '*',
      // 'padding-bottom': '*',
      // 'margin-top': '*',
      // 'margin-bottom': '*'
    }))]), transition(':leave', [style({
      opacity: 1,
      height: '*'
      // 'padding-top': '*',
      // 'padding-bottom': '*',
      // 'margin-top': '*',
      // 'margin-bottom': '*'
    }), animate('350ms ease-out', style({
      opacity: 0,
      height: '0px'
      // 'padding-top': '0px',
      // 'padding-bottom': '0px',
      // 'margin-top': '0px',
      // 'margin-bottom': '0px'
    }))])]);
  }
  static {
    this.fadeInSlow = trigger('fadeInSlow', [transition(':enter', [style({
      opacity: 0
    }), group([animate('0.9s 0.9s ease', style({
      opacity: 1
    }))])]), transition(':leave', [style({
      opacity: 1
    }), group([animate('0.1s 0.3s ease', style({
      opacity: 0
    }))])])]);
  }
};
class StlrPanelActionComponent {
  constructor() {
    this.showClose = false;
    this.isProcessing = false;
    this.isOpenSubject = new BehaviorSubject(false);
    this.isOpen$ = this.isOpenSubject.asObservable();
    this.closeRequestedSubject = new BehaviorSubject(false);
    this.closeRequested$ = this.closeRequestedSubject.asObservable();
  }
  setOpenState(isOpen) {
    this.isOpenSubject.next(isOpen);
  }
  close() {
    this.closeRequestedSubject.next(true);
  }
  static {
    this.ɵfac = function StlrPanelActionComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrPanelActionComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrPanelActionComponent,
      selectors: [["stlr-panel-action"]],
      inputs: {
        showClose: "showClose",
        isProcessing: "isProcessing"
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 3,
      consts: [[1, "panel"], [3, "click"]],
      template: function StlrPanelActionComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵconditionalCreate(0, StlrPanelActionComponent_Conditional_0_Template, 4, 4, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.isOpen$) ? 0 : -1);
        }
      },
      dependencies: [AsyncPipe],
      styles: [".panel[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;overflow:hidden;background-color:#fafafa;border:1px solid #e8e8e8;padding:15px;margin:0 15px 15px;color:#000}"],
      data: {
        animation: [Animations$1.fadeInSlow]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrPanelActionComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-panel-action',
      animations: [Animations$1.fadeInSlow],
      standalone: true,
      imports: [AsyncPipe],
      template: "@if (isOpen$ | async) {\n  <div class=\"panel\" [@fadeInSlow]=\"isOpen$ | async\">\n    <!-- <stlr-loading-bar *ngIf=\"isProcessing\" mode=\"indeterminate\"></stlr-loading-bar> -->\n    <ng-content></ng-content>\n    @if (showClose) {\n      <div>\n        <!-- Put a 'close' icon here instead of this button -->\n        <button (click)=\"close()\">Close</button>\n      </div>\n    }\n  </div>\n}\n",
      styles: [".panel{display:flex;flex-direction:row;justify-content:space-between;overflow:hidden;background-color:#fafafa;border:1px solid #e8e8e8;padding:15px;margin:0 15px 15px;color:#000}\n"]
    }]
  }], null, {
    showClose: [{
      type: Input
    }],
    isProcessing: [{
      type: Input
    }]
  });
})();
class StlrPanelFailComponent {
  constructor() {
    this.showClose = false;
    this.isOpenSubject = new BehaviorSubject(false);
    this.isOpen$ = this.isOpenSubject.asObservable();
    this.closeRequestedSubject = new BehaviorSubject(false);
    this.closeRequested$ = this.closeRequestedSubject.asObservable();
  }
  setOpenState(isOpen) {
    this.isOpenSubject.next(isOpen);
  }
  close() {
    this.closeRequestedSubject.next(true);
  }
  static {
    this.ɵfac = function StlrPanelFailComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrPanelFailComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrPanelFailComponent,
      selectors: [["stlr-panel-fail"]],
      inputs: {
        showClose: "showClose"
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 3,
      consts: [[1, "panel"], [3, "click"]],
      template: function StlrPanelFailComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵconditionalCreate(0, StlrPanelFailComponent_Conditional_0_Template, 4, 4, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.isOpen$) ? 0 : -1);
        }
      },
      dependencies: [AsyncPipe],
      styles: [".panel[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;overflow:hidden;background-color:#f41910;border:1px solid #c81109;padding:15px;margin:0 15px 15px;color:#fff}"],
      data: {
        animation: [Animations$1.fadeInSlow]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrPanelFailComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-panel-fail',
      animations: [Animations$1.fadeInSlow],
      standalone: true,
      imports: [AsyncPipe],
      template: "@if (isOpen$ | async) {\n  <div class=\"panel\" [@fadeInSlow]=\"isOpen$ | async\">\n    <!-- Put a failure icon here -->\n    <ng-content></ng-content>\n    @if (showClose) {\n      <div>\n        <!-- Put a 'close' icon here instead of this button -->\n        <button (click)=\"close()\">Close</button>\n      </div>\n    }\n  </div>\n}\n",
      styles: [".panel{display:flex;flex-direction:row;justify-content:space-between;overflow:hidden;background-color:#f41910;border:1px solid #c81109;padding:15px;margin:0 15px 15px;color:#fff}\n"]
    }]
  }], null, {
    showClose: [{
      type: Input
    }]
  });
})();
class StlrPanelSuccessComponent {
  constructor() {
    this.showClose = false;
    this.isOpenSubject = new BehaviorSubject(false);
    this.isOpen$ = this.isOpenSubject.asObservable();
    this.closeRequestedSubject = new BehaviorSubject(false);
    this.closeRequested$ = this.closeRequestedSubject.asObservable();
  }
  setOpenState(isOpen) {
    this.isOpenSubject.next(isOpen);
  }
  close() {
    this.closeRequestedSubject.next(true);
  }
  static {
    this.ɵfac = function StlrPanelSuccessComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrPanelSuccessComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrPanelSuccessComponent,
      selectors: [["stlr-panel-success"]],
      inputs: {
        showClose: "showClose"
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 3,
      consts: [[1, "panel"], [3, "click"]],
      template: function StlrPanelSuccessComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵconditionalCreate(0, StlrPanelSuccessComponent_Conditional_0_Template, 4, 4, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.isOpen$) ? 0 : -1);
        }
      },
      dependencies: [AsyncPipe],
      styles: [".panel[_ngcontent-%COMP%]{display:flex;flex-direction:row;justify-content:space-between;overflow:hidden;background-color:#24ad0f;border:1px solid #1a7e0b;padding:15px;margin:0 15px 15px;color:#fff}"],
      data: {
        animation: [Animations$1.fadeInSlow]
      }
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrPanelSuccessComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-panel-success',
      animations: [Animations$1.fadeInSlow],
      standalone: true,
      imports: [AsyncPipe],
      template: "@if (isOpen$ | async) {\n  <div class=\"panel\" [@fadeInSlow]=\"isOpen$ | async\">\n    <!-- Put a success icon here -->\n    <ng-content></ng-content>\n    @if (showClose) {\n      <div>\n        <!-- Put a 'close' icon here instead of this button -->\n        <button (click)=\"close()\">Close</button>\n      </div>\n    }\n  </div>\n}\n",
      styles: [".panel{display:flex;flex-direction:row;justify-content:space-between;overflow:hidden;background-color:#24ad0f;border:1px solid #1a7e0b;padding:15px;margin:0 15px 15px;color:#fff}\n"]
    }]
  }], null, {
    showClose: [{
      type: Input
    }]
  });
})();
class StlrPanelService {
  constructor() {
    this.panelStateSubject = new Subject();
    this.panelState$ = this.panelStateSubject.asObservable();
  }
  open(id, type) {
    this.panelStateSubject.next({
      id,
      isOpen: true,
      type
    });
  }
  close(id) {
    this.panelStateSubject.next({
      id,
      isOpen: false
    });
  }
  static {
    this.ɵfac = function StlrPanelService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrPanelService)();
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: StlrPanelService,
      factory: StlrPanelService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrPanelService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], null, null);
})();
var PanelType;
(function (PanelType) {
  PanelType[PanelType["Action"] = 0] = "Action";
  PanelType[PanelType["Success"] = 1] = "Success";
  PanelType[PanelType["Fail"] = 2] = "Fail";
  PanelType[PanelType["None"] = 3] = "None";
})(PanelType || (PanelType = {}));
class StlrPanelComponent {
  constructor() {
    this.isOpenSubject = new BehaviorSubject(false);
    this.isOpen$ = this.isOpenSubject.asObservable();
    this.currentPanelType = PanelType.None;
    this.panelService = inject(StlrPanelService);
  }
  ngOnInit() {
    if (this.id === null) {
      throw new Error('Panels require a unique ID');
    }
    this.subscribeToPanelCloseRequests();
    this.panelStateSubscription = this.panelService.panelState$.subscribe(state => {
      if (this.id === state.id && this.currentPanelType === state.type) return;
      if (this.currentPanelType !== PanelType.None) {
        this.updatePanelState({
          id: this.id,
          isOpen: false
        });
        setTimeout((self, nextState) => self.updatePanelState(nextState), 400, this, state);
      } else {
        this.updatePanelState(state);
      }
    });
  }
  ngOnDestroy() {
    if (this.panelStateSubscription) unsubscribe(this.panelStateSubscription);
    if (this.panelCloseRequestedSubscription) unsubscribe(this.panelCloseRequestedSubscription);
  }
  subscribeToPanelCloseRequests() {
    const panelOpenStates = [];
    if (this.panelAction != null) panelOpenStates.push(this.panelAction.closeRequested$);
    if (this.panelSuccess != null) panelOpenStates.push(this.panelSuccess.closeRequested$);
    if (this.panelFail != null) panelOpenStates.push(this.panelFail.closeRequested$);
    if (panelOpenStates.length > 0) {
      this.panelCloseRequestedSubscription = combineLatest(panelOpenStates).subscribe(closeRequests => {
        if (closeRequests.some(request => request === true)) {
          this.updatePanelState({
            id: this.id,
            isOpen: false
          });
        }
      });
    }
  }
  updatePanelState(state) {
    if (state.id === this.id) {
      this.isOpenSubject.next(state.isOpen);
      switch (state.type) {
        case PanelType.Action:
          this.currentPanelType = PanelType.Action;
          if (this.panelAction != null) this.panelAction.setOpenState(state.isOpen);
          if (this.panelSuccess != null) this.panelSuccess.setOpenState(false);
          if (this.panelFail != null) this.panelFail.setOpenState(false);
          break;
        case PanelType.Success:
          this.currentPanelType = PanelType.Success;
          if (this.panelAction != null) this.panelAction.setOpenState(false);
          if (this.panelSuccess != null) this.panelSuccess.setOpenState(state.isOpen);
          if (this.panelFail != null) this.panelFail.setOpenState(false);
          break;
        case PanelType.Fail:
          this.currentPanelType = PanelType.Fail;
          if (this.panelAction != null) this.panelAction.setOpenState(false);
          if (this.panelSuccess != null) this.panelSuccess.setOpenState(false);
          if (this.panelFail != null) this.panelFail.setOpenState(state.isOpen);
          break;
        default:
          this.currentPanelType = PanelType.None;
          if (this.panelAction != null) this.panelAction.setOpenState(false);
          if (this.panelSuccess != null) this.panelSuccess.setOpenState(false);
          if (this.panelFail != null) this.panelFail.setOpenState(false);
      }
    } else {
      this.currentPanelType = PanelType.None;
      this.isOpenSubject.next(false);
      if (this.panelAction != null) this.panelAction.setOpenState(false);
      if (this.panelSuccess != null) this.panelSuccess.setOpenState(false);
      if (this.panelFail != null) this.panelFail.setOpenState(false);
    }
  }
  static {
    this.ɵfac = function StlrPanelComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrPanelComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrPanelComponent,
      selectors: [["stlr-panel"]],
      contentQueries: function StlrPanelComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, StlrPanelActionComponent, 7);
          i0.ɵɵcontentQuery(dirIndex, StlrPanelSuccessComponent, 7);
          i0.ɵɵcontentQuery(dirIndex, StlrPanelFailComponent, 7);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panelAction = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panelSuccess = _t.first);
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.panelFail = _t.first);
        }
      },
      inputs: {
        id: "id"
      },
      ngContentSelectors: _c0,
      decls: 2,
      vars: 3,
      consts: [[1, "panel"]],
      template: function StlrPanelComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵprojectionDef();
          i0.ɵɵconditionalCreate(0, StlrPanelComponent_Conditional_0_Template, 3, 3, "div", 0);
          i0.ɵɵpipe(1, "async");
        }
        if (rf & 2) {
          i0.ɵɵconditional(i0.ɵɵpipeBind1(1, 1, ctx.isOpen$) ? 0 : -1);
        }
      },
      dependencies: [AsyncPipe],
      styles: [".panel[_ngcontent-%COMP%]{overflow:hidden}"],
      data: {
        animation: [Animations$1.dropdown]
      },
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrPanelComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-panel',
      animations: [Animations$1.dropdown],
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: true,
      imports: [AsyncPipe],
      template: "@if (isOpen$ | async) {\n  <div class=\"panel\" [@dropdown]=\"isOpen$ | async\">\n    <ng-content></ng-content>\n  </div>\n}\n",
      styles: [".panel{overflow:hidden}\n"]
    }]
  }], null, {
    id: [{
      type: Input
    }],
    panelAction: [{
      type: ContentChild,
      args: [StlrPanelActionComponent, {
        static: true
      }]
    }],
    panelSuccess: [{
      type: ContentChild,
      args: [StlrPanelSuccessComponent, {
        static: true
      }]
    }],
    panelFail: [{
      type: ContentChild,
      args: [StlrPanelFailComponent, {
        static: true
      }]
    }]
  });
})();
class StlrPanelDirective {
  constructor() {
    this.template = inject(TemplateRef);
  }
  static {
    this.ɵfac = function StlrPanelDirective_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrPanelDirective)();
    };
  }
  static {
    this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
      type: StlrPanelDirective,
      selectors: [["", "panel", ""]],
      standalone: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrPanelDirective, [{
    type: Directive,
    args: [{
      // eslint-disable-next-line @angular-eslint/directive-selector
      selector: '[panel]',
      standalone: false
    }]
  }], null, null);
})();
class Animations {
  static {
    this.contentChange = trigger('contentChange', [state('hidden', style({
      opacity: 0
    })), state('visible', style({
      opacity: 1
    })), transition('visible => hidden', [animate('300ms ease-out')]), transition('hidden => visible', [animate('300ms ease-in')])]);
  }
}
class StlrMultiViewComponent {
  constructor() {
    this._viewKey = null;
    this._viewMap = null;
    this.animationState = signal('hidden', ...(ngDevMode ? [{
      debugName: "animationState"
    }] : []));
  }
  set views(map) {
    this._viewMap = map;
    this.loadView();
  }
  set currentView(key) {
    this._viewKey = key;
    this.loadView();
  }
  get currentView() {
    return this._viewKey;
  }
  loadView() {
    this.animationState.set('hidden');
    if (this._viewKey == null || this._viewMap == null) {
      this._viewContainer.clear();
      return;
    }
    const componentOrTemplateRef = this._viewMap[this._viewKey];
    if (!componentOrTemplateRef) {
      throw new Error(`Unable to load view. Unknown view key: ${this._viewKey}`);
    }
    this._viewContainer.clear();
    if (componentOrTemplateRef instanceof TemplateRef) {
      this._viewContainer.createEmbeddedView(componentOrTemplateRef);
    } else {
      this._viewContainer.createComponent(componentOrTemplateRef);
    }
    this.animationState.set('visible');
  }
  static {
    this.ɵfac = function StlrMultiViewComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrMultiViewComponent)();
    };
  }
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: StlrMultiViewComponent,
      selectors: [["stlr-multi-view"]],
      viewQuery: function StlrMultiViewComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(_c5, 7, ViewContainerRef);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx._viewContainer = _t.first);
        }
      },
      inputs: {
        views: "views",
        currentView: "currentView"
      },
      standalone: false,
      decls: 3,
      vars: 1,
      consts: [["viewContainer", ""]],
      template: function StlrMultiViewComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div");
          i0.ɵɵelementContainer(1, null, 0);
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵproperty("@contentChange", ctx.animationState());
        }
      },
      encapsulation: 2,
      data: {
        animation: [Animations.contentChange]
      },
      changeDetection: 0
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrMultiViewComponent, [{
    type: Component,
    args: [{
      selector: 'stlr-multi-view',
      animations: [Animations.contentChange],
      changeDetection: ChangeDetectionStrategy.OnPush,
      standalone: false,
      template: "<div [@contentChange]=\"animationState()\">\n    <ng-container #viewContainer></ng-container>\n</div>\n"
    }]
  }], null, {
    _viewContainer: [{
      type: ViewChild,
      args: ['viewContainer', {
        read: ViewContainerRef,
        static: true
      }]
    }],
    views: [{
      type: Input,
      args: [{
        required: true
      }]
    }],
    currentView: [{
      type: Input,
      args: [{
        required: true
      }]
    }]
  });
})();

// noinspection ES6PreferShortImport
const declarations = [StlrCardComponent, StlrCardSectionComponent, StlrDrawerComponent, StlrHeaderComponent, StlrHeaderColumnComponent, StlrMenuComponent, StlrMenuHeadComponent, StlrMenuItemComponent, StlrPanelDirective, StlrMultiViewComponent];
const standaloneImports = [StlrPanelComponent, StlrPanelActionComponent, StlrPanelSuccessComponent, StlrPanelFailComponent];
const publicApi = [...declarations, ...standaloneImports];
class StlrLayoutModule {
  static {
    this.ɵfac = function StlrLayoutModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || StlrLayoutModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: StlrLayoutModule,
      declarations: [StlrCardComponent, StlrCardSectionComponent, StlrDrawerComponent, StlrHeaderComponent, StlrHeaderColumnComponent, StlrMenuComponent, StlrMenuHeadComponent, StlrMenuItemComponent, StlrPanelDirective, StlrMultiViewComponent],
      imports: [CommonModule, RouterModule, StlrPanelComponent, StlrPanelActionComponent, StlrPanelSuccessComponent, StlrPanelFailComponent],
      exports: [StlrCardComponent, StlrCardSectionComponent, StlrDrawerComponent, StlrHeaderComponent, StlrHeaderColumnComponent, StlrMenuComponent, StlrMenuHeadComponent, StlrMenuItemComponent, StlrPanelDirective, StlrMultiViewComponent, StlrPanelComponent, StlrPanelActionComponent, StlrPanelSuccessComponent, StlrPanelFailComponent]
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      providers: [StlrPanelService],
      imports: [CommonModule, RouterModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(StlrLayoutModule, [{
    type: NgModule,
    args: [{
      imports: [CommonModule, RouterModule, ...standaloneImports],
      declarations: [...declarations],
      exports: [...publicApi],
      providers: [StlrPanelService]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { StlrCardComponent, StlrCardSectionComponent, StlrDrawerComponent, StlrHeaderColumnComponent, StlrHeaderComponent, StlrLayoutModule, StlrMenuComponent, StlrMenuHeadComponent, StlrMenuItemComponent, StlrMultiViewComponent, StlrPanelActionComponent, StlrPanelComponent, StlrPanelDirective, StlrPanelFailComponent, StlrPanelService, StlrPanelSuccessComponent };
